<template lang="html">
   <div class="input">
      <div :class="{'input-group' : prepend||append}">
         <div class="input-group-prepend" v-if="prepend">
            <span class="input-group-text" @click="actionGroup" v-html="prepend"></span>
         </div>

         <input  
            :type="type"
            class="form-control"
            :placeholder="placeholder"
            :value="model"
            @input="updateSelf($event.target.value)"
         />
         <span class="separator"></span>
         
         <div class="input-group-append" @click="actionGroup" v-if="append">
            <span class="input-group-text" v-html="append"></span>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      type: {
         default: ''
      },
      prepend: {
         default: ''
      },
      append: {
         default: ''
      },
      name: {
         default: ''
      },
      model: {
         default: ''
      },
      action: {
         default: ''
      },
      placeholder: {
         default: undefined
      },
   },
   methods: {
      updateSelf(model) {
         this.$emit("input", model);
      },
      actionGroup(){
         EventBus.$emit('input-group:clicked',{name: this.name})
      }
   },
}
</script>

<style lang="less"></style>